import React from 'react'
import { Searchbox } from '@softura/fluentuipackage'
import './Searchbox.scss'

interface IProps {
  placeholder?: string,
  className?: string,
  onChange?: any,
  onSearch?: any,
  icon?: any,
  disabled?: boolean,
  underlined?: boolean,
  onBlur?:any
  value?: any
}
const Search = ({
  placeholder,
  onChange,
  onSearch,
  icon,
  disabled,
  underlined,
  className,
  onBlur,
  value
}:IProps) => {
  const cssStyles = {
    marginTop: 20,
    marginBottom: 0,
    'input::placeholder': {
      color: "black",
      fontSize: 12,
      fontFamily: 'Arial, san-serif',
      opacity: 0.5
    },
    '.ms-SearchBox-clearButton': {
      marginRight: '20px'
    }
  }
  return <div className='searchbox'>
    <Searchbox
    className = {`${cssStyles} ${className}`}
    placeholder = {placeholder}
    onChange = {onChange}
    onSearch = {onSearch}
    onBlur = {onBlur}
    icon = {icon}
    disabled = {disabled}
    underlined = {underlined}
    value={value}
  />
 </div>
}

export default Search
